import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import MobilityList from './MobilityList';

const MobilityListPage = () => {
    const { t } = useTranslation('mobilityList');

    const goToNewMobilityPage = useGoTo('/admin/mobilityoptions/add');
    const company = useCompany(true);
    const { permissions: accountPermissions } = useAccount();
    const hasPermission =
        hasPermissions(company?.permissions, [permissionKind.viewMobilities]) &&
        hasPermissions(accountPermissions, [permissionKind.updateMobility]);

    const extra =
        hasPermissions(accountPermissions, [permissionKind.createConfigurator]) && hasPermission ? (
            <Button icon={<PlusOutlined />} onClick={goToNewMobilityPage} type="primary">
                {t('mobilityList:actions.addMobility')}
            </Button>
        ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('mobilityList:options')}>
            <MobilityList />
        </ConsolePageWithHeader>
    );
};

export default MobilityListPage;
